import { render, staticRenderFns } from "./message-sample.vue?vue&type=template&id=3c1bf652"
import script from "./message-sample.vue?vue&type=script&lang=js"
export * from "./message-sample.vue?vue&type=script&lang=js"
import style0 from "./message-sample.vue?vue&type=style&index=0&id=3c1bf652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports